module.exports = __webpack_public_path__ + "static/media/why-jbfs.acd208ba.svg";